import * as React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

import LocationOnIcon from "@mui/icons-material/LocationOn";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/X";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";

export default function Footer({ setView }) {
  const go = (view) => () => {
    setView(view);
    window.scrollTo(0, 0);
  };

  const linkSx = {
    textDecoration: "none",
    fontSize: "0.875rem",
    color: "rgba(255,255,255,0.55)",
    cursor: "pointer",
    display: "block",
    mb: 1,
    transition: "color 0.2s",
    "&:hover": { color: "#0288D1" },
  };

  return (
    <Box sx={{ bgcolor: "#0D1B2A", color: "white", pt: 8, pb: 4 }}>
      <Container maxWidth="lg">
        <Grid container spacing={5} sx={{ mb: 6 }}>
          {/* Brand column */}
          <Grid item xs={12} md={4}>
            <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
              <DirectionsBusIcon sx={{ color: "#0288D1", fontSize: 28 }} />
              <Typography variant="h6" fontWeight={800} letterSpacing={1}>
                VISHMITHA{" "}
                <Box component="span" sx={{ color: "#0288D1" }}>
                  EXPRESS
                </Box>
              </Typography>
            </Stack>
            <Typography
              variant="body2"
              sx={{
                color: "rgba(255,255,255,0.5)",
                maxWidth: 290,
                lineHeight: 1.8,
                mb: 3,
              }}
            >
              Your trusted partner for intercity bus travel across Sri Lanka.
              Comfort, reliability, and safety  every journey.
            </Typography>
            <Stack direction="row" spacing={0.5}>
              {[<FacebookIcon />, <TwitterIcon />, <LinkedInIcon />].map(
                (icon, i) => (
                  <IconButton
                    key={i}
                    size="small"
                    sx={{
                      color: "rgba(255,255,255,0.45)",
                      "&:hover": {
                        color: "#0288D1",
                        bgcolor: "rgba(2,136,209,0.12)",
                      },
                      transition: "all 0.2s",
                    }}
                  >
                    {icon}
                  </IconButton>
                )
              )}
            </Stack>
          </Grid>

          {/* Quick links */}
          <Grid item xs={6} md={2}>
            <Typography
              variant="subtitle2"
              fontWeight={700}
              sx={{
                mb: 2.5,
                textTransform: "uppercase",
                letterSpacing: 1.2,
                color: "rgba(255,255,255,0.85)",
              }}
            >
              Quick Links
            </Typography>
            {[
              ["Home", "home"],
              ["About", "about"],
              ["Contact", "contact"],
            ].map(([label, view]) => (
              <Link key={view} onClick={go(view)} sx={linkSx}>
                {label}
              </Link>
            ))}
          </Grid>

          {/* Policies */}
          <Grid item xs={6} md={2}>
            <Typography
              variant="subtitle2"
              fontWeight={700}
              sx={{
                mb: 2.5,
                textTransform: "uppercase",
                letterSpacing: 1.2,
                color: "rgba(255,255,255,0.85)",
              }}
            >
              Policies
            </Typography>
            {[
              ["Privacy Policy", "policyPage"],
              ["Terms & Conditions", "policyPage"],
              ["Ticket Policy", "policyPage"],
            ].map(([label, view]) => (
              <Link key={label} onClick={go(view)} sx={linkSx}>
                {label}
              </Link>
            ))}
          </Grid>

          {/* Contact */}
          <Grid item xs={12} md={4}>
            <Typography
              variant="subtitle2"
              fontWeight={700}
              sx={{
                mb: 2.5,
                textTransform: "uppercase",
                letterSpacing: 1.2,
                color: "rgba(255,255,255,0.85)",
              }}
            >
              Contact Us
            </Typography>
            {[
              [<LocationOnIcon fontSize="small" />, "246/6B, Kumarasinghe Road, Badulla"],
              [<LocalPhoneIcon fontSize="small" />, "+94 766333030 | +94 775333030"],
              [<EmailIcon fontSize="small" />, "info@vishmitha.lk"],
            ].map(([icon, text], i) => (
              <Stack
                key={i}
                direction="row"
                spacing={1.5}
                alignItems="flex-start"
                sx={{ mb: 1.8 }}
              >
                <Box sx={{ color: "#0288D1", flexShrink: 0, mt: 0.15 }}>
                  {icon}
                </Box>
                <Typography
                  variant="body2"
                  sx={{ color: "rgba(255,255,255,0.5)", lineHeight: 1.6 }}
                >
                  {text}
                </Typography>
              </Stack>
            ))}
          </Grid>
        </Grid>

        <Divider sx={{ borderColor: "rgba(255,255,255,0.1)", mb: 4 }} />

        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems="center"
          spacing={1}
        >
          <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.35)" }}>
             {new Date().getFullYear()} Vishmitha Highway Express. All rights
            reserved.
          </Typography>
          <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.25)" }}>
            Powered by Metadew Technologies
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
}
